

























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Tiwen from "@/components/qa/tiwen.vue";
@Component({
  components: {
    Tiwen,
  },
})
export default class Name extends Vue {
  @Prop()
  private IfShow: any;
  @Watch("IfShow", { immediate: true })
  private IfShowChange() {
    this.detail = {
      pic_list: [],
    };
    this.ifVisible = this.IfShow;
  }
  private ifVisible: any = false;
  private detail: any = { pic_list: [] };
  private cancel() {
    this.$emit("cancel");
  }
  private updateData(d: any) {
    this.detail = d;
  }
  private sure() {
    if (!this.detail["名称"]) {
      this.$message.warning("请输入问题名称!");
      return;
    }
    // if (this.detail.pic_list.length == 0) {
    //   this.$message.warning("请上传图片!");
    //   return;
    // }
    this.$emit("change", this.detail);
  }
}
